<template>
  <div class="content-wrapper">
    <Loader v-if="!group.name" />
    <section v-if="group.name" class="group-info">
      <h3 class="impact-light group-count">Plan: <strong>{{ group.planName }}</strong></h3>
      <h2 class="impact-light group-count">Group: <strong>{{ group.name }}</strong></h2>
      <GroupMeterForm
        v-if="groupId && group.enabled && planId && (role !== 'Member')"
        v-bind:meter="meter"
        v-bind:groupId="groupId"
        v-bind:groupName="group.name"
        v-bind:planId="planId"
        v-bind:role="role"
      />
      <h3 v-if="!group.enabled" class="error">{{ $t("group.groupHome.infoMsg") }}</h3>
    </section>

    <Loader v-if="!projectsLoaded" />
    <h2 v-if="projectsLoaded" class="light project-count">Projects: <strong>{{ projects.length }}</strong></h2>
    <section v-if="projectsLoaded" class="cta-wrapper">
      <ProjectBlock
        v-for="(project, index) in projects"
        v-bind:key="index"
        v-bind:project="project"
        v-bind:role="role"
      />
      <ProjectCreateBlock
        v-if="group.enabled"
        v-bind:groupId="groupId"
      />
    </section>

    <Members
      v-if="planId && (role !== 'Member')"
      v-bind:groupId="groupId"
      v-bind:planId="planId"
      v-bind:enabled="group.enabled"
    />

  </div>
</template>

<script>
import Loader from '@/components/Loader.vue'
import ProjectCreateBlock from '@/components/group/ProjectCreateBlock.vue'
import ProjectBlock from '@/components/group/ProjectBlock.vue'
import Members from '@/components/group/Members.vue'
import GroupMeterForm from '@/components/group/GroupMeterForm.vue'

import { groupService } from '@/services/group.service'

export default {
  name: 'GroupHome',
  components: {
    Loader,
    ProjectCreateBlock,
    ProjectBlock,
    Members,
    GroupMeterForm
  },
  data () {
    return {
      role: '',
      showModal: false,
      groupId: 0,
      planId: 0,
      group: {},
      meter: 'Parent',
      projects: [],
      projectsLoaded: false
    }
  },
  created: function () {
    this.groupId = this.$route.params.groupId

    this.fetchGroup()
    this.fetchProjects()
  },
  methods: {
    fetchGroup: function () {
      // grab the group
      groupService.getGroup(this.groupId).then(group => {
        this.role = group.role
        if(this.role === 'Member' && !group.enabled){
          this.$router.push('/plans')
        } else {
          this.group = group
          if(group.description){
              this.group.description = decodeURIComponent(atob(group.description))
          }
          this.planId = group.planId
          if(group.meterActive) {
            this.meter = 'Own'
          }
        }
      }).catch((err) => {
        console.error('Something went wrong: ', err)
      })
    },
    fetchProjects: function () {
      // grab the group
      groupService.getProjects(this.groupId).then(projects => {
        let unarchivedProjects = []
        for(let project of projects){
          if(project.enabled){
            if(project.description){
                project.description = decodeURIComponent(atob(project.description))
            }
            unarchivedProjects.push(project)
          }
        }
        this.projects = unarchivedProjects
        this.projectsLoaded = true
      }).catch((err) => {
        console.error('Something went wrong: ', err)
      })
    }
  }
}
</script>

<style lang="scss">
.content-wrapper {
  .welcome {
    margin-bottom: 60px;
  }
}

section.group-info {
  margin-bottom: 85px;
}
</style>
